const self_adaption = function(){
    let condition = document.querySelectorAll("#condition");
    
      condition.forEach((e) => {
        console.log('99',e);
        let cHeight = e.clientHeight;
        let sHeight = e.scrollHeight;
        let num = sHeight - cHeight;
        console.log(num);
        if (num) {
          if (num>=3&&num<13) {
            e.style.fontSize = 18 + "px";
          }
          if (num>=13&&num<24) {
            e.style.fontSize = 16 + "px";
          }
          if (num>=24) {
            e.style.fontSize = 14 + "px";
          }
        } else {
          console.log("没有溢出");
        }
      });
  }
  export default self_adaption